import './style.scss';

export function all_specialists_block() {

    const block = document.querySelector('.all_specialists_block');
    if (!block) return;

}
